import * as React from 'react';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { ButtonGroup, Menu, MenuItem } from '@mui/material';

export default function TableConfigBalloon(props) {
    const { onSelect, code, refDif, refreshEditor, element } = props;

    const [tipo, setTipo] = React.useState();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event, tp) => {
        setAnchorEl(event.currentTarget);
        setTipo(tp);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const makeDivisao=(atual)=>{
        const rs = atual.getAttribute("rowspan");
        if (rs > 2) {
            atual.setAttribute('rowspan', rs - 1);
        } else {
            atual.removeAttribute('rowspan');
        }
        const cellIndex = atual.cellIndex;            
        const tr = getTrFromTd(atual);
        const outraTr = tr.nextElementSibling;
        const newCell = document.createElement("td");
        outraTr.appendChild(newCell);
        const tds = outraTr.querySelectorAll("td");
        for(let x=tds.length; x> 0; x--){
            const item = tds[x];                
            console.log( item );
            if( item ){                    
                let id = item.cellIndex;
                if (id < cellIndex ) {
                    item.nextElementSibling.textContent ="";
                    break;
                }
                const next = tds[x-1];
                item.textContent = next.textContent;
            }else{
                const next = tds[x-1];
                newCell.textContent = next.textContent;
            }
        }
    }
    const handleDividirColuna=()=>{
        const table = getTableFromTd(element);
        if (table) {    
            const cs = element.getAttribute("colspan");        
            if( !cs ){
                makeDivisao(element);
            }else{
                console.log( cs );
                let atual = element;
                for(let x =0; x< cs; x++){
                    makeDivisao(atual);
                    atual = element.nextElementSibling;
                }
            }
            
        }
    }
    const handleDividirLinha = () => {
        const table = getTableFromTd(element);
        if (table) {
            const cellIndex = element.cellIndex;
            const cs = element.getAttribute("colspan");            
            if (!cs) {
                alert('Não pode ser dividido');
                return;
            }
            if (cs > 2) {
                element.setAttribute('colspan', cs - 1);
            } else {
                element.removeAttribute('colspan');
            }

            const tr = getTrFromTd(element);
            const newCell = document.createElement("td");
            tr.appendChild(newCell);
            const tds = tr.querySelectorAll("td");
            console.log( tds.length );
            for(let x=tds.length; x> 0; x--){
                const item = tds[x];                
                console.log( item );
                if( item ){                    
                    let id = item.cellIndex;
                    if (id < cellIndex ) {
                        item.nextElementSibling.textContent ="";
                        break;
                    }
                    const next = tds[x-1];
                    item.textContent = next.textContent;
                }else{
                    const next = tds[x-1];
                    newCell.textContent = next.textContent;
                } 
            }
        }
        handleClose();
    }
    const podeMesclarColuna=()=>{
        const table = getTableFromTd(element);
        if (table) {
            // const cellIndex = element.cellIndex;
            // const rs = element.getAttribute("rowspan");
            const tr = getTrFromTd(element);
            const rows = table.rows;
            console.log( rows.length, tr.rowIndex);
            if( tr.rowIndex +1 === rows.length) return true;
        }
        return false;
    }
    const handleMescarColuna=()=>{
        const table = getTableFromTd(element);
        if (table) {
            const cellIndex = element.cellIndex;
            const rs = element.getAttribute("rowspan");
            const tr = getTrFromTd(element);
            const rows = table.rows;
            console.log( rs );

            element.setAttribute('rowspan', (rs) ? rs + 1 : 2);

            const outraTr = tr.nextElementSibling;
            const tds = outraTr.querySelectorAll("td");  
            const cs = element.getAttribute("colspan");
            if( cs){
                for(let x=0; x< cs; x++)
                tds[cellIndex+x].remove();
            }else{
                tds[cellIndex].remove();
            }
        }
    }
    const handleColSpan = () => {
        const table = getTableFromTd(element);
        if (table) {
            const cellIndex = element.cellIndex;
            const cs = element.getAttribute("colspan");

            const tr = getTrFromTd(element);
            const total = tr.cells.length;

            if (cellIndex + 1 == total) {
                alert('Não pode ser mesclado');
                return;
            }

            const nextTd = element.nextElementSibling;
            if (nextTd) {
                element.textContent = element.textContent + " " + nextTd.textContent;
                nextTd.remove();
            }
            element.setAttribute('colspan', (cs) ? cs + 1 : 2);
        }
        handleClose();
    }
    const podeDividir = () => {
        const table = getTableFromTd(element);
        if (table) {
            const cs = element.getAttribute("colspan");

            return (cs) ? false : true
        }
        return false;
    }
    const podeDividirColuna=()=>{
        const table = getTableFromTd(element);
        if (table) {
            const cs = element.getAttribute("rowspan");

            return (cs) ? false : true
        }
        return false;
    }
    const podeMesclar = () => {
        const table = getTableFromTd(element);
        if (table) {
            const cellIndex = element.cellIndex;
            const total = getMaxTotalTrFromTd(element);
            return (cellIndex + 1 == total);
        }
        return false;
    }
    const handleNovaLinha = (pos) => {
        const table = getTableFromTd(element);
        console.log( table )
        if (table) {
            const tr = getTrFromTd(element);
            console.log(tr);
            console.log(tr.rowIndex);
            const newRow = table.insertRow(tr.rowIndex + pos);
            const total = tr.cells.length;
            for (let x = 0; x < total; x++) {
                const cell1 = newRow.insertCell();
                cell1.textContent = `cel${x + 1}`;
            }
        }
        handleClose();
    }
    const handleRemoverColuna = () => {
        const table = getTableFromTd(element);
        if (table) {
            const cellIndex = element.cellIndex;
            console.log(cellIndex);
            let headerRows = table.querySelectorAll("thead tr");
            let dataRows = table.querySelectorAll("tbody tr");
            const total = getMaxTotalTrFromTd(element);
            for (let h of headerRows) {
                console.log(h);
                const totalRow = h.cells.length;
                if (totalRow > 1) {
                    const th = h.querySelector(":nth-last-child(1 of th)");
                    th.remove();
                }
            }
            for (let d of dataRows) {
                const tds = d.querySelectorAll("td");
                for (let td of tds) {
                    let id = td.cellIndex;
                    if (id === cellIndex) {
                        td.remove();
                        break;
                    }
                }
            }
        }
    }
    const handleNovaColuna = (pos) => {
        const table = getTableFromTd(element);
        if (table) {
            const cellIndex = element.cellIndex;


            let headerRows = table.querySelectorAll("thead tr");
            let dataRows = table.querySelectorAll("tbody tr");
            const total = getMaxTotalTrFromTd(element);
            headerRows.forEach((row, index) => {
                // Add new header cell                
                const newHeader = document.createElement("th");
                newHeader.textContent = " ";
                row.appendChild(newHeader);
                const totalRow = row.cells.length;
                if (total < totalRow) {
                    const tds = row.querySelectorAll("td");
                    let old = '';
                    for (let td of tds) {
                        console.log(td)
                        let id = td.cellIndex;
                        if (id < cellIndex + pos) continue;

                        if (id === cellIndex + pos) {
                            old = td.textContent;
                            td.textContent = `New Data ${index + 1}`;
                            continue;
                        }
                        let tmp = td.textContent;
                        td.textContent = old;
                        old = tmp;
                    }
                }
            });

            // Add new data cell to each row
            dataRows.forEach((row, index) => {
                const newCell = document.createElement("td");
                // newCell.textContent = `New Data ${index + 1}`; // Example data
                row.appendChild(newCell);

                const tds = row.querySelectorAll("td");
                let old = '';
                for (let td of tds) {
                    let id = td.cellIndex;
                    if (id < cellIndex + pos) continue;

                    if (id === cellIndex + pos) {
                        old = td.textContent;
                        td.textContent = `New Data ${index + 1}`;
                        continue;
                    }
                    let tmp = td.textContent;
                    td.textContent = old;
                    old = tmp;
                }
            });
        }
        handleClose();
    }
    const handleRemoveLinha = () => {
        const table = getTableFromTd(element);
        if (table) {
            const tr = getTrFromTd(element);
            console.log(tr);
            tr.remove();
        }
        handleClose();
    }
    function getTrFromTd(tdElement) {
        let currentElement = tdElement;
        while (currentElement && currentElement.tagName !== 'TR') {
            currentElement = currentElement.parentElement;
        }
        return currentElement; // Returns the <table> element or null if not found
    }
    function getTableFromTd(tdElement) {
        let currentElement = tdElement;
        while (currentElement && currentElement.tagName !== 'TABLE') {
            currentElement = currentElement.parentElement;
        }
        return currentElement; // Returns the <table> element or null if not found
    }
    const getMaxTotalTrFromTd = (td) => {
        const table = getTableFromTd(td);
        const rows = table.rows
        let total = 0;
        for (let r of rows) {
            if (total < r.cells.length) total = r.cells.length;
        }
        return total;
    }

    return (
        <div className='pd-balloon-panel pd-hidden'>
            <ButtonGroup variant="text" aria-label="Basic button group">
                <Button onClick={(e) => handleClick(e, 'novaLinha')}>Linha</Button>
                <Button onClick={(e) => handleClick(e, 'novaCol')}>Coluna</Button>
                <Button onClick={(e) => handleClick(e, 'mescrar')}>Mesclar</Button>
            </ButtonGroup>

            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                slotProps={{
                    list: {
                        'aria-labelledby': 'basic-button',
                    },
                }}
            >
                {tipo === 'novaLinha' &&
                    <React.Fragment>
                        <MenuItem onClick={() => handleNovaLinha(0)}>Nova a cima</MenuItem>
                        <MenuItem onClick={() => handleNovaLinha(+1)}>Nova a baixo</MenuItem>
                        <MenuItem onClick={handleRemoveLinha}>Remove Linha</MenuItem>
                    </React.Fragment>
                }
                {tipo === 'novaCol' &&
                    <React.Fragment>
                        <MenuItem onClick={() => handleNovaColuna(0)}>Nova a esquerda</MenuItem>
                        <MenuItem onClick={() => handleNovaColuna(+1)}>Nova a direita</MenuItem>
                        <MenuItem onClick={handleRemoverColuna}>Remove Coluna</MenuItem>
                    </React.Fragment>
                }
                {tipo === 'mescrar' &&
                    <React.Fragment>
                        <MenuItem onClick={handleColSpan} disabled={podeMesclar()}>Mesclar linha</MenuItem>
                        <MenuItem onClick={handleMescarColuna} disabled={podeMesclarColuna()}>Mesclar coluna</MenuItem>
                        <MenuItem onClick={handleDividirLinha} disabled={podeDividir()}>Dividir linha</MenuItem>
                        <MenuItem onClick={handleDividirColuna} disabled={podeDividirColuna()}>Dividir coluna</MenuItem>
                    </React.Fragment>
                }

            </Menu>
        </div>

    );
}
